// Tipos para Plano de Ação Híbrido e entidades relacionadas
// Estes tipos são aliases para melhor legibilidade - os tipos reais vêm do Supabase

export type StatusPlanoAcao = 'planejado' | 'em_execucao' | 'aguardando_verificacao' | 'concluido' | 'nao_eficaz' | 'cancelado';
export type StatusAcao = 'pendente' | 'em_andamento' | 'concluida' | 'bloqueada' | 'cancelada';
export type PrioridadeAcao = 'baixa' | 'media' | 'alta' | 'critica';
export type TipoEvidencia = 'documento' | 'imagem' | 'planilha' | 'relatorio' | 'outro';
export type ResultadoVerificacao = 'eficaz' | 'parcialmente_eficaz' | 'nao_eficaz';
export type CategoriaLicao = 'processo' | 'tecnica' | 'comunicacao' | 'recurso' | 'outro';

// Labels para exibição
export const STATUS_PLANO_LABELS: Record<StatusPlanoAcao, string> = {
  planejado: 'Planejado',
  em_execucao: 'Em Execução',
  aguardando_verificacao: 'Aguardando Verificação',
  concluido: 'Concluído',
  nao_eficaz: 'Não Eficaz',
  cancelado: 'Cancelado'
};

export const STATUS_ACAO_LABELS: Record<StatusAcao, string> = {
  pendente: 'Pendente',
  em_andamento: 'Em Andamento',
  concluida: 'Concluída',
  bloqueada: 'Bloqueada',
  cancelada: 'Cancelada'
};

export const PRIORIDADE_ACAO_LABELS: Record<PrioridadeAcao, string> = {
  baixa: 'Baixa',
  media: 'Média',
  alta: 'Alta',
  critica: 'Crítica'
};

export const RESULTADO_VERIFICACAO_LABELS: Record<ResultadoVerificacao, string> = {
  eficaz: 'Eficaz',
  parcialmente_eficaz: 'Parcialmente Eficaz',
  nao_eficaz: 'Não Eficaz'
};

export const TIPO_EVIDENCIA_LABELS: Record<TipoEvidencia, string> = {
  documento: 'Documento',
  imagem: 'Imagem',
  planilha: 'Planilha',
  relatorio: 'Relatório',
  outro: 'Outro'
};

export const CATEGORIA_LICAO_LABELS: Record<CategoriaLicao, string> = {
  processo: 'Processo',
  tecnica: 'Técnica',
  comunicacao: 'Comunicação',
  recurso: 'Recurso',
  outro: 'Outro'
};

// Helpers de cores
export const getStatusPlanoColor = (status: StatusPlanoAcao): string => {
  switch (status) {
    case 'planejado': return 'text-blue-600 bg-blue-100';
    case 'em_execucao': return 'text-yellow-600 bg-yellow-100';
    case 'aguardando_verificacao': return 'text-purple-600 bg-purple-100';
    case 'concluido': return 'text-green-600 bg-green-100';
    case 'nao_eficaz': return 'text-red-600 bg-red-100';
    case 'cancelado': return 'text-gray-600 bg-gray-100';
  }
};

export const getStatusAcaoColor = (status: StatusAcao): string => {
  switch (status) {
    case 'pendente': return 'text-gray-600 bg-gray-100';
    case 'em_andamento': return 'text-blue-600 bg-blue-100';
    case 'concluida': return 'text-green-600 bg-green-100';
    case 'bloqueada': return 'text-red-600 bg-red-100';
    case 'cancelada': return 'text-gray-600 bg-gray-100';
  }
};

export const getPrioridadeColor = (prioridade: PrioridadeAcao): string => {
  switch (prioridade) {
    case 'critica': return 'text-red-600 bg-red-100';
    case 'alta': return 'text-orange-600 bg-orange-100';
    case 'media': return 'text-yellow-600 bg-yellow-100';
    case 'baixa': return 'text-green-600 bg-green-100';
  }
};
